module.exports = function() {
  return new Worker(__webpack_public_path__ + "aee75613a39f69bb493d.worker.js");
};